import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export const VipStatementPage = () => {
	const { token } = useParams();

	// 使用完整的后端 API URL
	const API_URL = process.env.REACT_APP_API_URL || "";
	// 添加 download=1 参数，让后端返回 Content-Disposition: attachment，直接触发下载
	const downloadUrl = `${API_URL}/vip/statements/${token}/stream?download=1`;

	// 直接重定向到下载链接，触发 PDF 下载
	useEffect(() => {
		window.location.href = downloadUrl;
	}, [downloadUrl]);

	// 显示加载提示
	return (
		<div
			style={{
				width: "100vw",
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				gap: "20px",
			}}
		>
			<div>正在下載 PDF...</div>
			<div style={{ fontSize: "14px", color: "#666" }}>
				如果下載未自動開始，請
				<a href={downloadUrl} style={{ color: "#007bff", marginLeft: "4px" }}>
					點此下載
				</a>
			</div>
		</div>
	);
};
